<template>
    <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="card shadow p-4" style="width: 350px;">
            <div class="text-center mb-3">
                <img :src="logoUrl" alt="Company Logo" class="img-fluid" style="max-height: 60px;" />
            </div>
            <h3 class="text-center mb-3">Verify it's you</h3>
            <form @submit.prevent="submitCode">
                <label for="verificationCode" class="text-center mb-3">Enter the verification code sent to your email</label>
                <div class="mb-3">
                    <input id="verificationCode" v-model="verificationCode" class="form-control my-2" placeholder="Verification Code" required />
                </div>
                <button class="btn btn-primary w-100 mb-2" type="submit" :disabled="loading">
                    <output v-if="loading" class="spinner-border spinner-border-sm" aria-hidden="true"></output>
                    Submit Code
                </button>
            </form>
            <div class="text-center">
                Didn't get the code? <a href="#" class="text-decoration-none" @click.prevent="sendAgain">Send again</a>
            </div>
            <div class="text-center">
                <a href="#" class="text-decoration-none" @click.prevent="login">Login</a>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import eventBus from "@/utils/eventBus";
import { triggerMFA, checkAuth } from '@/utils/auth';

export default {
    data() {
        return {
            logoUrl: process.env.VUE_APP_LOGO_URL,
            verificationCode: '',
            loading: false
        };
    },
    methods: {
        async submitCode() {
            this.loading = true;
            if (!(await checkAuth())) {
                eventBus.emit('show-alert', { message: 'You need to log in to access this page.', type: 'danger' });
                this.$router.push('/');
            } else {
                try {
                    const response = await api.post('/v1/auth/mfa', {
                        otp: this.verificationCode,
                        otpChecker: localStorage.getItem('mfaSecret')
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 200) {
                        localStorage.setItem('mfaVerified', true);
                        this.$router.push('/dashboard');
                        eventBus.emit('show-alert', {
                            message: 'You have logged in successfully.',
                            type: 'success'
                        });
                    } else {
                        eventBus.emit('show-alert', { message: response.data.message, type: 'danger' });
                    }
                } catch (err) {
                    console.error(err);

                    if (err.response) {
                        console.error(err.response.data);
                        eventBus.emit('show-alert', { message: err.response.data.message, type: 'danger' });
                    } else if (err.request) {
                        console.error(err.request);
                        eventBus.emit('show-alert', { message: 'Something went wrong. Contact your administrator.', type: 'danger' });
                    } else {
                        eventBus.emit('show-alert', { message: 'Something went wrong. Contact your administrator.', type: 'danger' });
                    }

                    this.verificationCode = '';
                } finally {
                    this.loading = false;
                }
            }
        },
        async sendAgain() {
            await triggerMFA();
        },
        async login() {
            this.loading = true;
            this.$router.push('/');
        }
    }
};
</script>